import styled, { keyframes } from "styled-components";

const theme = {
  surface: '#1E1E1E',
  gold: '#D4AF37',
  goldHover: '#EACD65',
  text: '#FFFFFF',
  textSecondary: '#A9A9A9',
  border: '#333333',
};

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const ModalBox = styled.div`
  background-color: ${theme.surface};
  border-radius: 16px;
  padding: 2rem 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  border: 1px solid ${theme.border};
  max-width: 500px;
  width: 90%;
  text-align: center;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Title = styled.h2`
  color: ${theme.gold};
  font-size: 1.8rem;
  margin-top: 0;
  margin-bottom: 1rem;
`;

export const Message = styled.p`
  color: ${theme.textSecondary};
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  background: ${theme.gold};
  color: ${theme.surface};
  transition: all 0.3s ease;
  text-transform: uppercase;

  &:hover {
    background: ${theme.goldHover};
    transform: translateY(-2px);
  }
`;

export const SecondaryButton = styled(ActionButton)`
  background: transparent;
  color: ${theme.gold};
  border: 2px solid ${theme.gold};

  &:hover {
    background: rgba(212, 175, 55, 0.1);
    color: ${theme.goldHover};
    border-color: ${theme.goldHover};
  }
`;